import type { GeometryPadWidgetConfig } from '../geometrypad.model';

/**
 * Two independent shapes sharing a length value:
 * Triangle side c = Rectangle width w.
 */
export const SCALAR_DEPENDENCY_PRESET: GeometryPadWidgetConfig = {
  id: 'scalar-dependency',
  type: 'geometrypad',
  params: {
    elements: {
      r1: {
        type: 'Rectangle',
        params: { w: 8, h: 5 },
      },
      t1: {
        type: 'Triangle',
        params: { a: 5, b: 6, gamma: 60 },
      },
    },
  },
  display: {
    geometry: {
      label: { coloring: true },
    },
  },
};
